package io.horion.cv.pages.cv

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun Cv() {}